import clsx from "clsx"
import PropTypes from "prop-types"
import Spinner from "~/components/Common/Spinner"

const PaginationButtons = ({
  currentPage,
  totalPages = 1,
  setOptions,
  isFetching,
}) => {
  return (
    <div className="flex items-center">
      <button
        onClick={() => {
          setOptions((prev) => ({ ...prev, page: currentPage - 1 }))
        }}
        className={clsx(
          "w-8 h-8 rounded-full mr-1 hover:bg-primary hover:text-white bg-gray-200 text-gray-500",
        )}
        disabled={currentPage === 1}
      >
        prev
      </button>

      <div className="ml-2">{currentPage}/</div>
      <div className="mr-2">
        {isFetching ? <Spinner color="black" height="5px" /> : totalPages}
      </div>

      <button
        disabled={currentPage === totalPages}
        onClick={() => {
          setOptions((prev) => ({ ...prev, page: currentPage + 1 }))
        }}
        className={clsx(
          "w-8 h-8 rounded-full ml-1 hover:bg-primary hover:text-white bg-gray-200 text-gray-500",
        )}
      >
        next
      </button>
    </div>
  )
}

PaginationButtons.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  setOptions: PropTypes.func,
  isFetching: PropTypes.bool,
}

export default PaginationButtons
